/* global CSRF_TOKEN */

import noop from 'lodash/noop';

import { getGenericErrorMessage } from 'zoomforth_tools/error_messaging.js';

const ASYNC_REQUESTS = true;


export const serializeQueryParams = function(obj) {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p) && obj[p]) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
    }
  str.sort();
  return str.join('&');
};


export const sendRequest = function({ url, method, params, noCache=false, onSuccess=noop, onError }) {
  // this function abstracts away the boilerplate we use for standard POST calls
  // to our RPC APIs. It will post the params as an JSON encoded string in the body of the request
  if (!(method === 'POST' || method === 'PATCH' || method === 'DELETE' || method=='GET' || method=='PUT')) {
    throw new Error('Only GET, PATCH, DELETE, PUT, and POST supported for now');
  }
  
  if (!onError) {
    onError = function() {
      alert(getGenericErrorMessage());
    };
  }

  const xmlhttp = new XMLHttpRequest();
  xmlhttp.onreadystatechange = () => {
    if (xmlhttp.readyState == XMLHttpRequest.DONE) {
      if (xmlhttp.status >= 200 && xmlhttp.status < 300) {
        onSuccess(JSON.parse(xmlhttp.responseText));
      } else {
        onError(xmlhttp);
        // this will get the error logged:
        throw new Error(`Received unexpected status code from ${url} : ${xmlhttp.status}`);
      }
    }
  };
  xmlhttp.open(method, url, ASYNC_REQUESTS);
  xmlhttp.setRequestHeader('Content-type', 'application/json');

  if (noCache) {
    xmlhttp.setRequestHeader('Cache-Control', 'no-cache');
    xmlhttp.setRequestHeader('Pragma', 'no-cache');
  }

  xmlhttp.setRequestHeader('X-CSRF-Token', CSRF_TOKEN);
  if (params) {
    xmlhttp.send(JSON.stringify(params));
  } else {
    xmlhttp.send();
  }
};


export const sendRequestWithPromise = ({ url, method, params })=> {

  return new window.Promise((resolve, reject)=> {
    sendRequest({ url, method, params, onSuccess: resolve, onError: reject });
  });

};

export const loadAsBlob = (url)=>
  new window.Promise((resolve, reject)=> {
    try {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.onerror = ()=> {
        reject('Network error.');
      };
      xhr.onload = ()=> {
        if (xhr.status === 200) {
          resolve(xhr.response);
        }
        else {
          reject(`Loading error: ${xhr.statusText}`);
        }
      };
      xhr.send();
    }
    catch(err) {
      reject(err.message);
    }
  });
